import { FC } from 'react';
import { Box, Stack, Theme } from '@mui/material';
import { getFirstLastName } from '../../lib/helpers';
import { createUseStyles } from 'react-jss';
import Menu from '../menu';
import UserBadge from '../user-badge';
import Text from '../text';
import FlatButton from '../flat-button';
import useApp from '@/hooks/use-app.hook';
import ThemeModeControl from './theme-mode-control';
import Icon from '../icon';
import TailControl from './tail-control';
import useFeature from '@/hooks/use-feature.hook';

const useStyles = createUseStyles((theme: Theme) => ({
  userMenu: {
    minWidth: 250,
  },
  email: {
    color: theme.palette.text.secondary,
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

const UserMenu: FC = () => {
  const styles = useStyles();
  const { user, signOut } = useApp();
  const { canUseChat } = useFeature();
  const { displayName, email } = user!;
  const username = displayName || '';
  const { first, last } = getFirstLastName(username);
  const hasName = !!first || !!last;

  let NameEl = <Text>{email}</Text>;

  if (hasName) {
    NameEl = (
      <Stack gap={0.5}>
        <Text>{[first, last].join(' ')}</Text>
        <Text color="grey" className={styles.email}>
          {email}
        </Text>
      </Stack>
    );
  }

  const handleSignOut = () => {
    signOut();
  };

  const TriggerEl = (
    <Box py={1}>
      <UserBadge user={user!} />
    </Box>
  );

  return (
    <Box>
      <Menu
        trigger={TriggerEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        className={styles.userMenu}
      >
        <Box px={1}>
          {NameEl}

          <Stack direction="row" gap={0.5} alignItems="center" mb={1} mt={2}>
            <Icon name="display-settings" size="small" />
            <Text>Preferences</Text>
          </Stack>

          <Stack gap={1} mb={2}>
            <ThemeModeControl />
            {canUseChat && (
              <>
                <TailControl />
              </>
            )}
          </Stack>

          <Stack
            className={styles.footer}
            flexDirection="row"
            justifyContent="flex-end"
            mt={4}
            pt={2}
          >
            <FlatButton icon="log-out" label="Sign Out" onClick={handleSignOut} size="small" />
          </Stack>
        </Box>
      </Menu>
    </Box>
  );
};

export default UserMenu;
